// Widget Scripts
import headerTryOutButton from "./js/widgets/headerTryOutButton";

import tier1MainContentBackground from "./js/widgets/tier1MainContentBackground.js";
import tier1MainFeatureButtons from "./js/widgets/tier1MainFeatureButtons.js";
import tier1MainFeatureSeo from "./js/widgets/tier1MainFeatureSeo.js";

import tier2Cards from "./js/widgets/tier2Cards";
import tier2Seo from "./js/widgets/tier2Seo.js";

import tier3ClientPortfolioFeature from "./js/widgets/tier3ClientPortfolioFeature.js";
import tier3SeoBlockFeature from "./js/widgets/tier3SeoBlockFeature";

import tier4Sponsors from "./js/widgets/tier4Sponsors.js";

import footerButtons from "./js/widgets/footerButtons";
import complianceBadges from "./js/widgets/complianceBadges";

import AOS from "aos";
import "aos/dist/aos.css";
// Custom Theme Scripts
import "./js/localjs.js";
import "./js/layoutsSubpage.js";
import "./js/hauntSubpage.js";
import "./js/calloutStyles.js";

// Initialize Homepage Widgets
if (window.location.pathname === "/") {
  $(document).ready(function () {
    tier1MainContentBackground();
    tier1MainFeatureButtons();
    tier1MainFeatureSeo();

    tier2Cards();
    tier2Seo();

    tier3ClientPortfolioFeature();
    tier3SeoBlockFeature();

    tier4Sponsors();
  });
}

$(document).ready(function () {
  headerTryOutButton();
  footerButtons();
  complianceBadges();
  setTimeout(() => {
    AOS.init({
      anchorPlacement: "bottom-bottom",
      animatedClassName: "aos-animate",
      initClassName: "aos-init",
    });
  }, 2000);
});
